import { render } from "./LayoutContentRendererDefault.vue?vue&type=template&id=c494394e"
import script from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"
export * from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"
script.render = render

export default script